import * as types from 'src/store/types';
import apis from 'src/const/apis';
import request from 'src/utils/request';
import isMobile from 'is-mobile';

const actions = {
  // 重置所有的状态
  resetAllState({ commit }) {
    commit(`ad/create/${types.RESET_STATES}`);
  },

  // 获取自定义列列表 参数type类型为String||Number 每次只能获取一类缓存
  getCustomContentList(store, data) {
    return request.get(apis.custom_content.newList, data);
  },

  // 添加自定义选项
  addCustomContent(store, data) {
    return request.post(apis.custom_content.newCreate, data);
  },

  // 更新自定义选项
  updateCustomContent(store, data) {
    return request.post(apis.custom_content.newUpdate, data);
  },

  // 获取自定义选项详情
  getCustomContentDetail(store, data) {
    return request.get(apis.custom_content.newDetail, data);
  },
  // 删除自定义选项
  removeCustomContent(store, data) {
    return request.post(apis.custom_content.newDelete, data);
  },
  getWhaletoken(store, data) {
    return request.get(apis.whale_token, data);
  },
  liteOpenCheck({ getters }, country = getters['account/permissionData']?.account?.country) {
    if (country && isMobile()) {
      return request.get(apis.lite_open_check, { country })
        .then(res => res.data.is_opened)
        .catch(() => false);
    }
    return false;
  },
};

export default actions;
